import { render, staticRenderFns } from "./RecognitionMessage.vue?vue&type=template&id=d6dd0abc&"
import script from "./RecognitionMessage.vue?vue&type=script&lang=js&"
export * from "./RecognitionMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports